import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { MovieModel } from '../../core/interfaces/movie.model';
import { ParameterModel } from 'src/app/core/interfaces/parameter.model';
import { ParametersService } from 'src/app/core/services/parameters.service';

@Component({
  selector: 'app-ui-movie',
  templateUrl: './ui-movie.component.html',
  styleUrls: ['./ui-movie.component.scss']
})
export class UiMovieComponent implements OnInit {

  @Input() movie: MovieModel;
  @Input() useHover: boolean = true;
  nombreCompletoDirector = '';
  fotoPrincipal = '';
  movieLink = '';

  esEstreno = false;
  esCinema = false;
  isFree = false;

  PARAMS: ParameterModel;

  hoverItem = false;//Esto es para evitar una sobre ejecucion del sanitizer desde el html. 

  constructor(private router: Router, public san: DomSanitizer, private parametersService: ParametersService) { }

  async ngOnInit() {
    await this.parametersService.getAllParameters().then((res) => {
      this.PARAMS = res;
    });

    // cocardas: free -> estreno -> en sala
    if (this.movie.paymentOption == 0) {
      this.isFree = true;
    }

    if (!this.isFree) {
      this.esEstreno = this.movie.categories.find((c) => {
        return c.id === parseInt(this.PARAMS.ESTRENOS_ID.value);
      }) ? true : false;

      if (!this.esEstreno) {
        this.esCinema = this.movie.categories.find((m) => {
          return m.id === parseInt(this.PARAMS.CINEMA_ID.value);
        }) ? true : false;
      }
    }

    if (this.movie.directors.length > 0) {
      var dires = '';
      this.movie.directors.forEach(element => {
        dires = dires + element.name + ' ' + element.lastName + ', ';
      });
      dires = dires.substr(0, dires.length - 2);
      this.nombreCompletoDirector = dires;// resp.directors[0].name + ' ' + resp.directors[0].lastName;

      //this.nombreCompletoDirector = this.movie.directors[0].name;
      //this.nombreCompletoDirector += ' ' + this.movie.directors[0].lastName;
    }

    let fotoP = this.movie.pictures.find((picture) => picture.isDefault == true);

    const temas = ['animals', 'architecture', 'nature', 'people', 'tech'];

    this.fotoPrincipal = fotoP
      ? environment.apiEndpoint + fotoP.pictureLink
      : // : './assets/img/2019_3_7_18_47_450000073.jpg';

      // Se agrega una imagen random solamente para probar en desarrollo
      'http://placeimg.com/640/480/' + temas[Math.floor(Math.random() * temas.length)];

    this.movieLink = "/movie/" + this.movie.id;
  }

  goMovie($event: MouseEvent, idMovie, external = false) {
    const url = '/movie/' + idMovie;
    $event.preventDefault();

    if (external) { window.open(url, "_blank"); }
    else { this.router.navigateByUrl(url); }
  }
}
